export const forMatLabel = (label: string) => {
  return label.replace(/\s+/g, "").replace("'", "")
}
